import { render } from "./SearchPopularQueriesList.vue?vue&type=template&id=33674654&ts=true"
import script from "./SearchPopularQueriesList.vue?vue&type=script&lang=ts"
export * from "./SearchPopularQueriesList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__